<template>
  <Layout @currentPage="currentPage" :hasPagination="true" :hasBreadcrumbs="true" :amount="amount.aantal" :amountToShow="amountToShow">
    <div class="content">
      <div class="page-content" ref="tableContent">
        <MainTitle :title="this.$router.currentRoute.name"  />
        <LotTable @selectedAmount="gotAmountToShow" :totalItems="amount.aantal" @selectedRow="gotLot" :lots="this.lots" @sorting="gotSorting"/>
      </div>
      <div class="sidebar">
        <TableAction v-bind:hasButton="false"/>
        <TableDetail v-if="this.selectedLot"  height="44" :details="this.selectedLot"/>
        <TableDetailList v-if="this.selectedLot" :parts="this.selectedLot.subparts"/>
      </div>
    </div>
  </Layout>
</template>
<script>
// @ is an alias to /src
import Layout from "@/layouts/Dashboard";
import Loading from "@/components/base/Loading";
import LotTable from "@/components/TblLot";
import TableAction from "@/components/TableAction";
import TableDetail from "@/components/TblLotDetail";
import TableDetailList from "@/components/TblLotDetailList";
import MainTitle from "@/components/base/MainTitle";

export default {
  name: "traceability-lottable",
  data () {
    return {
      isLoading: false,
      lots: null,
      amount: 0,
      selectedLot: null,
      pagina: 1,
      sortingOn: "lotID",
      isAscending: true,
      amountToShow: 8
    }
  },
  components: {
    Layout,
    Loading,
    LotTable, 
    MainTitle, 
    TableAction,
    TableDetail,
    TableDetailList
  },
  computed: {
    maxRows: function () {
      let heightContent = this.$refs.tableContent.clientHeight;
      let heightSingleRow = 76

      return Math.ceil(heightContent / heightSingleRow) - 2
    }
  },
  mounted() {
    this.amountToShow = this.maxRows
    this.getData()
  },
  methods: {
    gotAmountToShow(val) {
      if(val == 9) {
        this.amountToShow = this.maxRows
      } else {
        this.amountToShow = parseInt(val)
      }
      this.pagina = Math.ceil(this.amount.aantal / parseInt(val))
      this.getData()
    },
    getData() {
      var that = this
      this.isLoading = true
      let offset = this.pagina != 1 ? (this.pagina * this.amountToShow) - this.amountToShow : 0
      let asc = this.isAscending ? "A" : "D"
      this.$http.get(this.$endpoint + 'traceability/lottbl/' + this.sortingOn + '/' + asc + '/' + this.amountToShow + '/' + offset)
      .then(response => {
        that.amount = response.data.pop()
        that.lots = response.data
        that.selectedLot = null

        switch(this.sortingOn) {
          case 'ref':
            if(this.isAscending) {
              that.lots.sort((a, b) => (a.ref > b.ref) ? 1 : -1)
            } else {
              that.lots.sort((a, b) => (a.ref < b.ref) ? 1 : -1)
            }
            break;
        }
      })
      .catch(error => {
        if (error.response.status === 401) {
          this.$store
          .dispatch("logout")
          .then(() => this.$router.push("/login"))
          .catch(err => console.log(err));
        // } else {
        //   that.$swal(
        //     'Oops that went wrong?',
        //     `Please contact the admin with the following info: ${ error }`,
        //     'error'
        //   );
        }
      })
    },
    currentPage(page) {
      this.pagina = page // someValue
    },
    gotSorting(sort) {
      this.isAscending = sort.asc
      this.sortingOn = sort.on
      this.getData()
    },
    gotLot(lot) {
      this.selectedLot = lot // someValue
    },
    gotRefresh(val) {
      this.getData()
    },
    gotRefreshPageData(val) {
      this.getData()
    },
  },
  watch: {
    pagina: function (val) {
      this.getData()
    } 
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/content.scss";
@import "@/style/components/sidebar.scss";
/* 
.sidebar {
  background-color: red;
} */
</style>;
